import React from "react";
import {withNamespaces} from "react-i18next";
import {Link} from "react-router-dom";

const BreadcrumbExtend = ({items, t}) => {

    const breadcrumbItem = items.map((item, idx) => {
        return ((items.length - 1) === idx) ? (
            <li key={idx} className={'breadcrumb-item ' + {active: item.active}} >
                { t(item.value) }
            </li>
        ) : (
            <li key={idx} className={'breadcrumb-item ' + {active: item.active} }>
                <Link to={item.path}>{ t(item.value) }</Link>
            </li>
        );
    });

    return (
        <ol className="breadcrumb">
            <li className={'breadcrumb-item active'}>
                    <Link to={'/panel'}>
                        <i className="fas fa-home"> </i>
                    </Link>
            </li>
            { breadcrumbItem }
        </ol>
    )
};

export default withNamespaces()(BreadcrumbExtend);
